'use client';
import React from 'react';
import { toast } from 'sonner';
import Icon from '@/components/ui/AppIcon';

const rewards = [
  { id: 'reward-001', title: 'Ücretsiz İçecek', desc: 'Herhangi bir içeceği ücretsiz al', cost: 200, icon: '☕', available: true },
  { id: 'reward-002', title: 'Ücretsiz Yiyecek', desc: 'Herhangi bir yiyecek veya atıştırmalık', cost: 150, icon: '🥐', available: true },
  { id: 'reward-003', title: '%20 İndirim', desc: 'Bir sonraki siparişinde %20 indirim', cost: 100, icon: '🏷️', available: true },
  { id: 'reward-004', title: 'Ekstra Boyut', desc: 'Siparişini Venti\'ye yükselt', cost: 50, icon: '⬆️', available: true },
  { id: 'reward-005', title: 'Ücretsiz Eklenti', desc: 'Herhangi bir eklenti ücretsiz', cost: 25, icon: '✨', available: true },
  { id: 'reward-006', title: 'Reserve Bar Deneyimi', desc: 'Özel Reserve Bar deneyimi', cost: 400, icon: '👑', available: false },
];

interface AvailableRewardsProps {
  stars: number;
}

export default function AvailableRewards({ stars }: AvailableRewardsProps) {
  function redeem(reward: typeof rewards[0]) {
    if (stars < reward.cost) {
      toast.error('Yeterli yıldız yok', { description: `Bu ödül için ${reward.cost - stars} ★ daha gerekiyor` });
      return;
    }
    // Backend integration: POST /api/rewards/redeem with rewardId
    toast.success(`${reward.title} kullanıldı!`, { description: '${reward.cost} Yıldız bakiyenizden düşüldü' });
  }

  return (
    <div className="px-4 py-4">
      <h2 className="text-foreground font-bold text-base mb-3">Ödüllerini Kullan</h2>
      <div className="space-y-3">
        {rewards.map((reward) => {
          const canRedeem = stars >= reward.cost;
          return (
            <div
              key={reward.id}
              className={`bg-card rounded-2xl p-4 flex items-center gap-3 card-shadow border ${
                canRedeem ? 'border-transparent' : 'border-border'
              }`}
            >
              <div className={`w-12 h-12 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0 ${
                canRedeem ? 'bg-gold-light' : 'bg-muted'
              }`}>
                {reward.icon}
              </div>
              <div className="flex-1 min-w-0">
                <p className={`font-bold text-sm ${canRedeem ? 'text-foreground' : 'text-muted-foreground'}`}>
                  {reward.title}
                </p>
                <p className="text-muted-foreground text-xs">{reward.desc}</p>
                <div className="flex items-center gap-1 mt-1">
                  <Icon name="StarIcon" size={12} variant="solid" className="text-gold" />
                  <span className="text-gold font-bold text-xs">{reward.cost} ★</span>
                </div>
              </div>
              <button
                onClick={() => redeem(reward)}
                disabled={!canRedeem}
                className={`px-3 py-2 rounded-xl text-xs font-bold transition-all active:scale-95 ${
                  canRedeem
                    ? 'bg-primary text-white hover:bg-primary/90' :'bg-muted text-muted-foreground cursor-not-allowed'
                }`}
              >
                {canRedeem ? 'Kullan' : `${reward.cost - stars}★ eksik`}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}